import './BtnLoader.css'
function BtnLoader(){
  return(
    <div className='loader-container'>
      <button>
        <div className="loader"></div>
      </button>
    </div>
  )
}
export default BtnLoader